import ApiService from "@/services/ApiService";

const REPOSITORY_URL = "valores";

const ValoresRepository = {
  refrescar() {
    return ApiService.get(`${REPOSITORY_URL}/refrescar`);
  },

  listaInventario(idAgricultor) {
    let data = {
      idAgricultor,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_inventario`, data);
  },

  listaPersonal(idEstablecimiento, idGrupoExplotacion) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_personal`, data);
  },

  listaTemporada() {
    return ApiService.get(`${REPOSITORY_URL}/lista_temporada`);
  },

  listaTemporadaAgricultor(idEstablecimiento, idGrupoExplotacion) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_temporada_agricultor`, data);
  },

  temporadaActual() {
    return ApiService.get(`${REPOSITORY_URL}/temporada_actual`);
  },

  listaFichaAgricola(idEstablecimiento, idGrupoExplotacion, idTemporada) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
      idTemporada,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_ficha_agricola`, data);
  },

  /**
   * Retorna la lista de cultivos parametrizados
   * @returns {Promise<object[]>}
   */
  listaCultivos() {
    return ApiService.get(`${REPOSITORY_URL}/lista_cultivos`);
  },

  /**
   * Crear cultivo parametrizado
   * @param {number} tipo Tipo de cultivo (1 CulturaVerano, 2 CulturaInvierno)
   * @param {string} nombre Nombre del cultivo
   * @returns {Promise<object>}
   */
  crearCultivo(tipo, nombre) {
    let data = {
      tipo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_cultivo`, data);
  },

  /**
   * Actualizar cultivo parametrizado
   * @param {number} idCultivo Identificador del cultivo a actualizar
   * @param {number} tipo Tipo de cultivo (1 CulturaVerano, 2 CulturaInvierno)
   * @param {string} nombre Nombre del cultivo
   * @returns {Promise<object>}
   */
  actualizarCultivo(idCultivo, tipo, nombre) {
    let data = {
      idCultivo,
      tipo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_cultivo`, data);
  },

  /**
   * Eliminar cultivo parametrizado
   * @param {number} idCultivo Identificador del cultivo a eliminar
   * @returns {Promise<object>}
   */
  debajaCultivo(idCultivo) {
    let data = {
      idCultivo,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_cultivo`, data);
  },

  /**
   * Retorna la lista de variedades parametrizadas
   * @returns {Promise<Array<object>>}
   */
  listaVariedad() {
    return ApiService.get(`${REPOSITORY_URL}/lista_variedades`);
  },

  /**
   * Crea una nueva variedad
   * @param {number} idCultivo Identificador del cultivo que se asociará a la variedad
   * @param {string} nombre Nombre de la variedad
   * @returns {Promise<object>}
   */
  crearVariedad(idCultivo, nombre) {
    let data = {
      idCultivo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_variedad`, data);
  },

  /**
   * Actualizar una variedad parametrizada
   * @param {number} idVariedad Identificador de la variedad a actualizar
   * @param {number} idCultivo Identificador del cultivo
   * @param {string} nombre Nombre de la variedad
   * @returns {Promise<object>}
   */
  actualizarVariedad(idVariedad, idCultivo, nombre) {
    let data = {
      idVariedad,
      idCultivo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_variedad`, data);
  },

  /**
   * Eliminar variedad parametrizada
   * @param {number} idVariedad Identificador de la variedad a eliminar
   * @returns {Promise<null>}
   */
  debajaVariedad(idVariedad) {
    let data = {
      idVariedad,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_variedad`, data);
  },

  listaVariedadTemporada(idTemporada) {
    let data = {
      idTemporada,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_variedad_temporada`, data);
  },

  listaVariedadTemporadaAgricultor(
    idEstablecimiento,
    idGrupoExplotacion,
    idTemporada
  ) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
      idTemporada,
    };
    return ApiService.get(
      `${REPOSITORY_URL}/lista_variedad_temporada_agricultor`,
      data
    );
  },

  listaProducto() {
    return ApiService.get(`${REPOSITORY_URL}/lista_producto`);
  },

  listaProductoAgricultor(idAgricultor) {
    let data = {
      idAgricultor,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_productos_agricultor`, data);
  },

  crearProductoAgricultor(idAgricultor, productos) {
    let data = {
      idAgricultor,
      productos,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/crear_productos_agricultor`,
      data
    );
  },

  /**
   * Actualizar producto de un Agricultor
   * @param {number} idAgricultor Identificador del Agricultor (requerido)
   * @param {number} idProductoAgricultor Identificador del producto (requerido)
   * @param {number} idUnidadMedida Identificador de la unidad de medida (requerido)
   * @param {string} nombre Nombre del producto (requerido)
   * @param {number} numeroRegistro Numero registro del producto
   * @param {string} nombreRegistrante Nombre de la empresa que registra el producto
   * @param {string} tipoUso Tipo de uso del producto ex. Fertilizante
   * @param {string} principioActivo Principo activo del producto
   * @returns {!Promise<object>} async null
   */
  actualizarProductoAgricultor(
    idAgricultor,
    idProductoAgricultor,
    idUnidadMedida,
    nombre,
    numeroRegistro,
    nombreRegistrante,
    tipoUso,
    principioActivo
  ) {
    let data = {
      idAgricultor,
      idProductoAgricultor,
      idUnidadMedida,
      nombre,
      numeroRegistro,
      nombreRegistrante,
      tipoUso,
      principioActivo,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_producto_agricultor`,
      data
    );
  },

  /**
   * Dar debaja de una lista de productos de un agricultor
   * @param {number} idAgricultor Identificador del Agricultor
   * @param {number[]} idProductosAgricultor Lista de los identificadores de los productos a dar debaja
   * @returns {Promise<null>}
   */
  debajaProductoAgricultor(idAgricultor, idProductosAgricultor) {
    let data = {
      idAgricultor,
      idProductosAgricultor,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/debaja_productos_agricultor`,
      data
    );
  },

  /**
   * Retornar lista completa de productos importados desde la página de la Senave
   * @returns {Promise<object[]>}
   */
  listaProductosSenave() {
    return ApiService.get(`${REPOSITORY_URL}/lista_productos_senave`);
  },

  /**
   * Actualizar la lista global de productos importados de la Senave
   * @param {object[]} listaProductos Lista de productos importados desde planilla
   * @returns {Promise<object>}
   */
  actualizarProductosSenave(listaProductos) {
    let data = {
      productos: listaProductos,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_productos_senave`,
      data
    );
  },

  /**
   * Retornar lista productos cultivo que antes eran retornados de lista_productos
   * @returns {Promise<object[]>}
   */
  listaProductosCultivo() {
    return ApiService.get(`${REPOSITORY_URL}/lista_productos_cultivo`);
  },

  /**
   * Crea un nuevo producto cultivo
   * @param {number} idVariedad Identificador de la variedad que se asociará al producto
   * @param {string} nombre Nombre del producto cultivo
   * @returns {Promise<object>}
   */
  crearProductoCultivo(idVariedad, nombre) {
    let data = {
      idVariedad,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_producto_cultivo`, data);
  },

  /**
   * Actualizar una producto cultivo
   * @param {number} idProductoCultivo Identificador del producto cultivo
   * @param {number} idVariedad Identificador de la variedad a actualizar
   * @param {string} nombre Nombre de la variedad
   * @returns {Promise<object>}
   */
  actualizarProductoCultivo(idVariedad, idProductoCultivo, nombre) {
    let data = {
      idVariedad,
      idProductoCultivo,
      nombre,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_producto_cultivo`,
      data
    );
  },

  /**
   * Eliminar producto cultivo
   * @param {number} idProductoCultivo Identificador del producto cultivo a eliminar
   * @returns {Promise<null>}
   */
  debajaProductoCultivo(idProductoCultivo) {
    let data = {
      idProductoCultivo,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_producto_cultivo`, data);
  },

  listaRubro() {
    return ApiService.get(`${REPOSITORY_URL}/lista_rubro`);
  },

  listaGrupoExplotacion() {
    return ApiService.get(`${REPOSITORY_URL}/lista_grupo_explotacion`);
  },

  fichaGanadera(idEstablecimiento, idGrupoExplotacion, idTemporada) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
      idTemporada,
    };
    return ApiService.get(`${REPOSITORY_URL}/ficha_ganadera`, data);
  },

  listaRetiros(idEstablecimiento, idGrupoExplotacion) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
    };
    return ApiService.get(`${REPOSITORY_URL}/retiros`, data);
  },

  /**
   * Retornar lista de unidades de medida disponibles de asociar con un producto químico
   * @returns {Promise<object[]>}
   */
  listaUnidadMedida() {
    return ApiService.get(`${REPOSITORY_URL}/lista_unidades_medida`);
  },

  /**
   * Crear una nueva unidad de medida que se puede usar en los productos quimicos
   * @param {string} nombre nombre de la nueva unidad medida a crear
   * @returns {Promise<object>}
   */
  crearUnidadMedida(nombre) {
    let data = {
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_unidad_medida`, data);
  },

  /**
   * Actualizar el nombre de una unidad de medida
   * @param {number} idUnidadMedida Identificador de la unidad de medida a actualizar
   * @param {string} nombre Nombre modificado de la unidad de medida
   * @returns {Promise<object>}
   */
  actualizarUnidadMedida(idUnidadMedida, nombre) {
    let data = {
      idUnidadMedida,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_unidad_medida`, data);
  },

  /**
   * Eliminar unidad de medida
   * @param {number} idUnidadMedida Identificador de la unidad de medida a eliminar
   * @returns {Promise<null>}
   */
  debajaUnidadMedida(idUnidadMedida) {
    let data = {
      idUnidadMedida,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_unidad_medida`, data);
  },
};

export default ValoresRepository;
